<div class="container d-flex flex-column justify-content-center align-items-center">
  <div class="loader-container">
    <div class="loading-text">Loading<span class="dots"></span></div>
  </div>
  <div class="progress-bar-container">
    <div class="progress-bar" [style.width.%]="progress"></div>
  </div>
  <div class="progress-info">
    {{ completedRequests }} / {{ totalRequests }} {{'Progress-Bar.Progress'| translate}}
  </div>
</div>